module.exports = __webpack_public_path__ + "static/slagen-hex-gray-fe3ef3af50e3590520db5f2d60868d68.png";